<template>
  <div v-if="applicantProfile" id="applicant-edit-tab-personal-data">
    <vs-table
      v-if="
        applicantApplicationsPage && applicantApplicationsPage.results.length
      "
      :data="applicantApplicationsPage.results"
    >
      <template slot="header">
        <h3>Bewerbungen</h3>
      </template>
      <template slot="thead">
        <vs-th>Stelle</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Nachricht</vs-th>
        <vs-th>Datum</vs-th>
        <vs-th />
      </template>

      <template slot-scope="{ data }">
        <vs-tr v-for="entry in data" :key="entry.id" :data="entry">
          <vs-td>
            <template v-if="entry.project">
              <router-link
                :to="{
                  name: 'project.edit',
                  params: { id: entry.project.id }
                }"
              >
                {{ entry.project.number }} - {{ entry.project.title }}
              </router-link>
            </template>
            <template v-if="entry.vacancy">
              {{
                entry.project
                  ? `(${entry.vacancy.number})`
                  : entry.vacancy.number
              }}
              -
              {{
                entry.project ? `(${entry.vacancy.title})` : entry.vacancy.title
              }}
            </template>
          </vs-td>

          <vs-td>
            {{ entry.state && entry.state.name ? entry.state.name : "-" }}
          </vs-td>

          <vs-td>
            {{ entry.message }}
          </vs-td>

          <vs-td>
            {{ $d(new Date(entry.createdAt), "long") }}
          </vs-td>
          <vs-td>
            <vs-button
              v-if="entry.isManual"
              @click="confirmDeleteRecord(entry.id)"
            >
              <i class="far fa-trash" />
            </vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <AddVacancy
      :applicant-i-d="this.$route.params.id"
      @applicantVacanciesChanged="refetchVacancies()"
    />
    <ApplicationAs v-model="profile" />
    <div style="text-align: right">
      <vs-button class="mt-3" @click="save()">Speichern</vs-button>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import ApplicationAs from "../form/ApplicationAs";
import editFormMixin from "@/mixins/editFormMixin.js";
import AddVacancy from "@/components/applicant/AddVacancy";

export default {
  components: {
    ApplicationAs,
    AddVacancy
  },
  mixins: [
    editFormMixin({
      idFields: ["availibilty", "jobExperience", "leadershipExperience"],
      legacyIDFields: ["driverLicenses", "wantedJobTypes", "wantedOccupations"],
      dataProp: "profile"
    })
  ],
  props: {
    profileId: { type: String, required: true }
  },
  data() {
    return {
      saveInterval: null,
      fetchFailed: false,
      deleteId: null
    };
  },
  apollo: {
    applicantApplicationsPage: {
      query: gql`
        query ApplicantApplicationsPage($applicant: ID!, $page: Int) {
          applicantApplicationsPage(applicant: $applicant, page: $page) {
            results {
              id
              project {
                id
                number
                title
              }
              vacancy {
                id
                number
                title
              }
              state {
                id
                name
              }
              message
              createdAt
              isManual
            }
            total
          }
        }
      `,
      variables() {
        return {
          applicant: this.$route.params.id,
          page: 1
        };
      }
    },
    applicantProfile: {
      query: gql`
        query ApplicantProfile($id: ID!) {
          applicantProfile(id: $id) {
            id
            salaryIs
            salaryCar
            salaryWanted
            salaryFix
            salaryVariable
            driverLicenses {
              id
              name
            }
            wantedJobTypes {
              id
              name
            }
            wantedOccupation
            wantedOccupations {
              id
              name
            }
            profileNote
            ownCar
            mobilityMotorcycle
            mobilityBicycle
            mobilityPublicTransport
            mobilityRadius
            mobilityComment
            hobbies
            degree
            jobExperience {
              id
              name
            }
            leadershipExperience {
              id
              name
            }
            availibilty {
              id
              name
            }
            availibiltyCustom
          }
        }
      `,
      result() {
        this.updateCurrent();
      },
      variables() {
        return {
          id: this.profileId
        };
      }
    }
  },
  computed: {
    profile: {
      get() {
        return this.applicantProfile;
      },
      // eslint-disable-next-line
      set(v) {
        this.save(false);
      }
    }
  },
  watch: {
    profile: {
      deep: true,
      handler(v) {
        this.profile = v;
      }
    }
  },
  methods: {
    updateValue() {
      this.profile = this.applicantProfile;
    },
    refetchVacancies() {
      this.$apollo.queries["applicantApplicationsPage"].refetch();
    },
    confirmDeleteRecord(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei eine Stellen Zuordnung zu löschen. Bist du sicher?`,
        accept: this.deleteRecord,
        acceptText: "Löschen",
        cancelText: "Abbrechen"
      });
    },
    deleteRecord() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($applicantId: ID!, $applicationId: ID!) {
              removeApplication(
                applicantId: $applicantId
                applicationId: $applicationId
              ) {
                id
              }
            }
          `,
          variables: {
            applicationId: this.deleteId,
            applicantId: this.$route.params.id
          }
        })
        .then(() => {
          this.refetchVacancies();
        });
    },
    async persist() {
      let input = this.getInput();
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!, $input: ApplicantProfileInput!) {
              updateApplicantProfile(id: $id, input: $input) {
                id
                wantedOccupations {
                  id
                  category {
                    id
                  }
                }
                applicant {
                  id
                }
              }
            }
          `,
          variables: {
            id: this.profileId,
            input
          }
        })
        .then(data => {
          const aplicantId = data.data.updateApplicantProfile.applicant.id;
          const wantedOccupations =
            data.data.updateApplicantProfile.wantedOccupations || [];
          const occupationCategoryIds = wantedOccupations
            .filter(o => o.category != null)
            .map(o => o.category.id);
          this.$apollo
            .mutate({
              mutation: gql`
                mutation($id: ID!, $input: ApplicantInput!) {
                  updateApplicant(id: $id, input: $input) {
                    id
                  }
                }
              `,
              variables: {
                id: aplicantId,
                input: {
                  occupationCategories: occupationCategoryIds
                }
              }
            })
            .then(data => console.log(data))
            .catch(error => console.log(error));
          return data;
        })
        // eslint-disable-next-line
        .then((data) => {
          this.reportSuccess(input);
        })
        .catch(error => {
          this.reportUnhandledError(error);
        });
    }
  }
};
</script>
